





































































































































































import { Component } from 'vue-property-decorator';
import { CardForm } from '@/components/bwaff';
import Form, { Send } from '@/components/form-base';
import IntercomMixin from '@/components/helpers/intercom-mixin';
import { mixins } from 'vue-class-component';

import { validationMixin, Validation } from 'vuelidate';
import { required } from 'vuelidate/lib/validators';
import { ValidationProperties, ValidationGroups } from 'vue/types/vue';
import RegisterStep from '@/views/pages/components/register-step.vue';
import CurrencyMixin from '@/components/helpers/currency-mixin';

import api, { AppExeptionsDialogsApi } from '@/components/app-exceptions-resolver/dialogs/api';

const validations = {
  currencyId: {
    required
  },
  phoneNumber: {
    required
  }
};

@Component({
  components: {
    CardForm,
    RegisterStep
  },
  validations: validations
})
export default class RegisterCurrency extends mixins<Form>(Form, validationMixin, CurrencyMixin,IntercomMixin) {
  edit: boolean = true;
  show_password: boolean = false;
  email: string = '';
  password: string = '';
  yourName: string = '';
  promoCode: string = '';
  phoneNumber: string = '';
  loading: boolean = false;
  isPhoneNumberValid: boolean = false;

  form: any = {};

  messengerType: string = '';
  messengerAccount: string = '';
  currencyId: string = '';

  billingIssue: boolean = false;

  // @ts-ignore
  $v:  ValidationProperties<typeof validations> & ValidationGroups & Validation;

  api: AppExeptionsDialogsApi = api;

  get messengers() {
    return [ 
      {
        id: 'WhatsApp',
        icon: 'fab fa-whatsapp'
      }, 
      {
        id: 'Telegram',
        icon: 'fab fa-telegram'
      }
    ];
  }

  getClientErrors(field: string) {
    let errors: string[] = [];
    switch(field) {
      case 'currencyId':
        if(this.$v.currencyId.$dirty) {
          if(!this.$v.currencyId.required) {
            errors.push(
              this.t('Account currency is required')
            );
          }
        }
        break;
      case 'phoneNumber':
        if(this.$v.phoneNumber.$dirty) {
          if(!this.$v.phoneNumber.required) {
            errors.push(
              this.t('{0} is required',[ this.t('Phone Number') ])
            );
          }
        }
        break;
    }

    return errors;
  }

  getError(input: string):  any[] {
    const errors = this.errorsDict[input] || [];
    return this.getClientErrors(input).concat(errors);
  }

  get disabledBtn(){
    return this.$v.$invalid || !this.isPhoneNumberValid;
  }

  phoneNumberValidationUpdate(value){
    this.isPhoneNumberValid=value;
  }

  phoneNumberBlur(){
    this.$v.phoneNumber.$touch();
    this.clearError('phoneNumber')
  }

  @Send(true)
  async submit() {
    this.loading = true;
    return this.api.putUser( {
      messengerType: this.messengerType,
      messengerAccount: this.messengerAccount,
      currencyId: this.currencyId,
      phoneNumber: this.phoneNumber,
      language: this.$i18n.locale,
    })
    .then(() => {
      this.$router.push({
        name: 'app.blank'
      });

      this.$store.commit('updateUser', this.form);
    })
    .finally(() => {
      this.loading = false;
    });
  }
}
